export default function (array, status) {
  return array.filter((item) => item.status === status);
}
